import { ApolloError } from '@apollo/client';

import {
  GQLGwsEligibilityResponse,
  GQLGwsErrorType,
  GQLGwsRequest,
  GQLGwsType,
} from '../../gql.generated';

export const getGwsResponse = (
  gwsType: GQLGwsType,
  response: GQLGwsEligibilityResponse,
  request: GQLGwsRequest,
  loading: boolean,
  error?: ApolloError,
  isAuthenticated = true
) => {
  if (isAuthenticated && (error || response?.isEligible == null)) {
    console.warn('Error in useGwsEligibilityCheck.', gwsType, request, error);
  }

  if (
    !isAuthenticated ||
    gwsType === GQLGwsType.INVALID_TYPE ||
    error ||
    response?.isEligible == null
  ) {
    return {
      globalFeatureOn: false,
      gwsFeatureOn: false,
      isEligible: false,
      loading,
      error: GQLGwsErrorType.UNSUPPORTED_FEATURE,
    };
  }
  return {
    ...response,
    loading,
    // TODO: Remove the next line once the GQL response is fixed
    error:
      response.globalFeatureOn || response.error == 'UNSUPPORTED_FEATURE'
        ? response.error
        : null,
  };
};
